import { createAction } from '@reduxjs/toolkit'
import { actions as clientActions } from '@gocanvas/client'
const { loadFormData } = clientActions

// if an action is only used to update state in a single slice, it should be defined in that slice
// if an action is used to update state in multiple slices, it should be defined here
// this prevents potential circular dependency issues (more info: https://redux-toolkit.js.org/usage/usage-guide#exporting-and-using-slices)

// form
export { loadFormData }

// TODO: This needs to be moved to the FCK at some point
// import { saveApp } from 'apps/formsCreationKit/store/reducers/settings/appSettings'
// export { saveApp }

// app
export const updateOnSave = createAction('app/updateOnSave')
export const updateOnPublish = createAction('app/updateOnPublish')
// entries
export const addEntry = createAction('entries/addEntry')
export const updateEntry = createAction('entries/updateEntry')
export const updateIndex = createAction('entries/updateIndex')
export const deleteEntry = createAction('entries/deleteEntry')
export const copyEntry = createAction('entries/copyEntry')
// sheets
export const addSheet = createAction('sheets/addSheet')
export const addTableSheet = createAction('sheets/addTableSheet')
export const addListSheet = createAction('sheets/addListSheet')
export const updateSheet = createAction('sheets/updateSheet')
export const updateSheetSection = createAction('sheets/updateSheetSection')
export const deleteSheet = createAction('sheets/deleteSheet')
export const deleteChildSheet = createAction('sheets/deleteChildSheet')
export const deleteLoopSheet = createAction('sheets/deleteLoopSheet')
export const copySheet = createAction('sheets/copySheet')
export const copyTableOrSimpleLoopSheet = createAction(
  'sheets/copyTableOrSimpleLoopSheet'
)
export const splitSheet = createAction('sheets/splitSheet')
export const editSheet = createAction('sheets/editSheet')
export const convertToLoopScreen = createAction('sheets/convertToLoopScreen')
export const promoteToLoopScreen = createAction('sheets/promoteToLoopScreen')
export const convertToTableScreen = createAction('sheets/convertToTableScreen')
export const promoteToTableScreen = createAction('sheets/promoteToTableScreen')
export const convertListToScreen = createAction('sheets/convertListToScreen')
export const convertScreenToList = createAction('sheets/convertScreenToList')
// importData
export const importFormData = createAction('importData/importFormData')
// referenceData
export const addReferenceDataEntry = createAction(
  'referenceData/addReferenceDataEntry'
)
export const updateReferenceDataEntry = createAction(
  'referenceData/updateReferenceDataEntry'
)
export const deleteReferenceDataEntry = createAction(
  'referenceData/deleteReferenceDataEntry'
)

export const addLiveDataEntry = createAction(
  'liveData/addLiveDataEntry'
)

export const updateLiveDataEntry = createAction(
  'liveData/updateLiveDataEntry'
)

export const deleteLiveDataEntry = createAction(
  'liveData/deleteLiveDataEntry'
)

export const createDataSourceParam = createAction(
  'dataSourceParams/createDataSourceParam'
)

export const updateDataSourceParam = createAction(
  'dataSourceParams/updateDataSourceParam'
)

export const createLiveDataEntry = ({
  guid,
  dependent_entry,
  live_data_source_id,
  live_data_column,
  data_source_context_id,
  dataContextLabel,
}) => {
  return addLiveDataEntry({
    guid,
    dependent_entry,
    live_data_column,
    live_data_source_id,
    data_source_context_id,
    dataContextLabel
  })
}

